<template>
  <div class="login">
    <ValidationObserver v-if="step === 1" tag="form" ref="obs1" key="login-stu">
      <message-box
        :error="errorMessage[1]"
        :boxHeight="385"
        key="login"
        :globalConfig='globalConfig'
        @off="close"
        class="login student">
        <template v-slot:title>
          <span class="login_title">登录</span>
          <!-- <div class="login_role_change" @click="step=0"></div> -->
        </template>
        <template v-slot:body>
          <LoginTabs
            :data="category"
            :more="true"
            route-name="internshipList"
            :activeIndex.sync="loginType"
            :color='globalConfig.vice'
          />
          <div v-if="loginType === 0">
            <div class="body__item">
              <validation-provider rules="required" v-slot="{ errors }" name="学员编号">
                <input
                  class="body__item__input"
                  placeholder="学员编号"
                  type="text"
                  v-model="loginInfo.username"
                />
                <span class="tip" v-show="errors.length>0">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="body__item">
              <validation-provider rules="required" v-slot="{ errors }" name="密码">
                <PasswordInput
                  v-model="loginInfo.password"
                  @enter="handleLogin"
                  placeholder="密码"
                />
                <span class="tip" v-show="errors.length>0">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="code" v-if="loginType === 1">
            <div class="body__item">
              <validation-provider rules="required" v-slot="{ errors }" name="手机号" ref="phone">
                <input
                  class="body__item__input"
                  placeholder="手机号"
                  type="text"
                  v-model="loginInfo.phone"
                />
                <span class="tip" v-show="errors.length>0">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="body__item">
              <validation-provider rules="required" v-slot="{ errors }" name="验证码">
                <input
                  type="text"
                  class="body__item__input code_input"
                  v-model="loginInfo.code"
                  placeholder="验证码"
                  autocomplete="off"
                />
                <span class="code tip">{{ errors[0] }}</span>
              </validation-provider>
              <sendCode
              :globalConfig='globalConfig'
               @check="checkPhone"
               :mobile="loginInfo.phone"
               :closeTimer="closeTimer"
               :type="1"
               :captcha.sync="captcha"
              />
            </div>
            <div class="body__item" v-show="captcha"> <div id="captcha"/></div>
          </div>
        </template>
        <template v-slot:footer>
          <Button
            :globalConfig='globalConfig'
            @handleClick="handleLogin"
            :text="`登录${loginType === 1 ? '/注册' : ''}`"
            buttonType="login"
          />
          <p class="body__sign" v-show="compType!==3">
            <span @click="showResetModal" :style="setColor">忘记密码</span>
            <!-- <span @click="showDeleteModal">注销</span> -->
          </p>
        </template>
      </message-box>
    </ValidationObserver>
    <ValidationObserver v-if="step === 2" tag="form" ref="obs1" key="login-info">
      <message-box
        :globalConfig='globalConfig'
       :error="errorMessage[2]"
       :showicon="false" key="register"
       @off="close"
       class="register">
        <template v-slot:title>
          <span class="login_title">注册</span>
        </template>
        <template v-slot:body>
          <div class="body__item info" style="margin-top:30px">
            <validation-provider
              mode="lazy"
              rules="required"
              v-slot="{ errors }"
              name="城市"
              ref="obs1">
              <span class="lab two">城市</span>
              <el-select
                class="body__item__select"
                v-model="studentInfo.areaCode"
                filterable
                placeholder="请选择城市"
                name="city"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.cityCode"
                  :label="item.name"
                  :value="item.cityCode"
                >
                </el-option>
              </el-select>
              <span class="tip" v-show="errors.length>0">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="body__item info">
            <validation-provider rules="required|nameMin|nameMax" v-slot="{ errors }" name="姓名">
              <span class="lab two">姓名</span>
              <input
                class="body__item__input"
                v-model="studentInfo.realname"
                onkeydown="if(event.keyCode==13){event.keyCode=0;event.returnValue=false;}"
                show-password
                placeholder="请输入姓名"
              />
              <span class="tip" v-show="errors.length>0">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="body__item info">
            <validation-provider
              mode="lazy"
              rules="required"
              v-slot="{ errors }"
              name="年级">
              <span class="lab two">年级</span>
              <el-select
                class="body__item__select"
                v-model="studentInfo.grid"
                filterable
                placeholder="请选择年级"
                name="grid"
              >
                <el-option
                  v-for="item in grid"
                  :key="item.gridCode"
                  :label="item.name"
                  :value="item.gridCode"
                >
                </el-option>
              </el-select>
              <span class="tip" v-show="errors.length>0">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div class="body__item info">
            <span>
              <span class="lab two">性别</span>
              <div class="sex_select" style="text-align:left">
                <!-- :class="{ active: studentInfo.sex === 1 }" -->
                <div
                  class="sex male"
                  @click="studentInfo.sex = 1"
                  :class="{ active: studentInfo.sex === 1 }"
                  :style="studentInfo.sex === 1 ? setBgColor : ''"
                >
                  <span>男生</span>
                </div>
                <div
                  class="sex female"
                  :class="{ active: studentInfo.sex === 0 }"
                  :style="studentInfo.sex === 0 ? setBgColor : ''"
                  @click="studentInfo.sex = 0"
                >
                  <span>女生</span>
                </div>
              </div>
            </span>
          </div>
          <div class="body__agreement">
            <input
             class="body__agreement__checkbox"
             name="agreement"
             id="agreement"
             type="checkbox"
             v-model="isAgree"
             v-show="false"/>
            <label class="body__agreement__label" for="agreement"></label>
            <span>
              已阅读并同意
              <span class="show-agreement" :style="setColor" @click="showAgreement = true">《用户协议》</span>
            </span>
          </div>
        </template>
        <template v-slot:footer>
          <Button
            :globalConfig='globalConfig'
            :disable="regDisabled"
            @handleClick="handleLogin"
            text="完成"
            buttonType="login"
          />
          <p class="backToSignin" :style="setColor" @click="step = 1, loginType = 1">返回登录</p>
        </template>
      </message-box>
    </ValidationObserver>
    <ValidationObserver v-if="step === 0" tag="form" ref="obs1" key="login-teacher">
      <message-box
        :globalConfig='globalConfig'
        :error="errorMessage[0]"
        :boxHeight="385" key="login"
        @off="close"
        class="login teacher">
        <template v-slot:title>
          <span class="login_title">教师端登录</span>
          <span class="login_role_change" @click="step=1"></span>
        </template>
        <template v-slot:body>
          <div>
            <div class="body__item" style="margin-top: 32px">
              <validation-provider rules="required" v-slot="{ errors }" name="教师编号">
                <input
                  class="body__item__input"
                  placeholder="教师编号"
                  type="text"
                  v-model="teacherInfo.username"
                />
                <span class="tip" v-show="errors.length>0">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="body__item">
              <validation-provider rules="required" v-slot="{ errors }" name="密码">
                <PasswordInput
                  v-model="teacherInfo.password"
                  @enter="handleTeacherLogin"
                  placeholder="密码"
                />
                <span class="tip" v-show="errors.length>0">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="body__item">
              <validation-provider mode="lazy" rules="required" v-slot="{ errors }" name="分校">
                <el-select
                  class="body__item__select"
                  v-model="teacherInfo.cityCode"
                  style="width:164px"
                  filterable
                  placeholder="选择分校"
                >
                  <el-option
                    v-for="item in cityList"
                    :key="item.cityCode"
                    :label="item.name"
                    :value="item.cityCode"
                  >
                  </el-option>
                </el-select>
                <span class="tip" v-show="errors.length>0">{{ errors[0] }}</span>
              </validation-provider>
              <validation-provider mode="lazy" rules="required" v-slot="{ errors }" name="教师类型">
                <el-select
                  class="body__item__select"
                  style="width:164px"
                  v-model="teacherInfo.type"
                  filterable
                  placeholder="选择教师类型"
                >
                  <el-option value="0" label="主讲"></el-option>
                  <el-option value="1" label="辅导"></el-option>
                  <el-option value="2" label="助教"></el-option>
                </el-select>
                <span class="tip" v-show="errors.length>0">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <Button
            :globalConfig='globalConfig'
            @handleClick="handleTeacherLogin"
            text="登录"
            buttonType="login"
          />
        </template>
      </message-box>
    </ValidationObserver>

    <Agreement :active.sync="showAgreement" />
  </div>
</template>

<script>
import { Select, Option } from 'element-ui';
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import MessageBox from '@/components/Login/MessageBoxnew.vue';
import Button from '@/components/Login/LoginButton.vue';
import {
  studentsRegComplete, studentLogin, studentLoginByCode,getCityList,
  getGrid, autoSignupAfterLogin
} from '@/services/login';
import LoginTabs from '@/components/Login/LoginTabs.vue';
import SendCode from '@/components/Login/SendCodeNew.vue';
import Agreement from '@/components/Login/Agreement.vue';
import PasswordInput from '@/components/Login/PasswordInput.vue';
import { mapState} from 'vuex'

extend('required', {
  ...required,
  message: '{_field_}不能为空',
});
extend('nameMax', {
  validate: (value) => {
    let sum = 0;
    const valueTemp = `${value}`;
    // eslint-disable-next-line no-restricted-syntax
    for (const char of valueTemp) {
      const charCode = char.charCodeAt();
      if (charCode >= 32 && charCode <= 122) {
        sum += 1;
      } else {
        sum += 2;
      }
    }
    return sum <= 20;
  },
  message: '名称最多20个字符或者10个汉字',
});
extend('nameMin', {
  validate: (value) => {
    let sum = 0;
    const valueTemp = `${value}`;
    // eslint-disable-next-line no-restricted-syntax
    for (const char of valueTemp) {
      const charCode = char.charCodeAt();
      if (charCode >= 32 && charCode <= 122) {
        sum += 1;
      } else {
        sum += 2;
      }
    }
    return sum >= 4;
  },
  message: '名称最少4个字符或者2个汉字',
});
export default {
  name: 'login',
  data() {
    return {
      captcha: false,
      loginInfo: {
        username: '',
        password: '',
        // cityCode: '',
        phone: '',
        code: '',
      },
      step: 1,
      loginType: 0,
      closeTimer: true,
      showAgreement: false,
      category: [
        {
          category: '账号密码登录',
        },
        {
          category: '手机验证码登录',
        },
      ],
      studentInfo: {
        areaCode: '',
        realname: '',
        grid: '',
        code: '',
        sex: 1,
        type: 1,
        pCode: '',
      },
      teacherInfo: {
        username: '',
        password: '',
        cityCode: '',
        type: '',
      },
      isAgree: false,
      grid: [],
      cityList: [],
      code: '',
      errorMessage: {
        0: '',
        1: '',
        2: '',
      },
    };
  },
  created() {
    window.TAL_UC.configNVC({
      renderToEle: '#captcha',
      isH5: false,
      onloadCallback() {},
      failCallback() {},
    });
  },
  mounted() {
    getCityList().then(({ data }) => {
      this.cityList = data;
    });

    getGrid().then(({ data }) => {
      this.grid = data;
    });

    if(Number(this.compType) === 3) {
      this.category = [
        {
          category: '账号密码登录',
        }
      ]
    }
  },
  components: {
    MessageBox,
    Button,
    ValidationProvider,
    ValidationObserver,
    'el-select': Select,
    'el-option': Option,
    SendCode,
    LoginTabs,
    Agreement,
    PasswordInput,
  },
  methods: {
    checkPhone() {
      this.$refs.phone.validate();
    },
    async handleLogin() {
      this.errorMessage = this.$options.data().errorMessage;
      try {
        if (!await this.$refs.obs1.validate()) {
          return;
        }
        let res;
        if (this.loginType === 0) {
          res = await studentLogin({competitionId:this.id,...this.loginInfo});
          this.autoSignUpForDiagnose();
        } else if (this.loginType === 1) {
        // eslint-disable-next-line no-underscore-dangle
          const _this = this;
          _this.captcha = false;
          res = await new Promise((resolve, rej) => {
            const param = {
              data: {
                phone: _this.loginInfo.phone,
                phone_code: '86',
                sms_code: _this.loginInfo.code,
                competitionId:this.id
              },
              success: async (re) => {
                _this.captcha = false;
                if (re.errcode === 11021) {
                  const param2 = {
                    slideCallback: 'loginSms',
                    slideParams: param,
                    failCallback(err) {
                      _this.captcha = false;
                      _this.$message.showMessage({ info: err.errmsg });
                    },
                  };
                  _this.captcha = true;
                  window.TAL_UC.showSlide(param2);
                } else if (re.errcode === 0) {
                  this.studentInfo.code = re.data.code;
                  if (re.data.is_reg === 1) {
                    this.step = 2;
                    this.loginType = 2;
                    this.studentInfo.type = 1;
                    this.studentInfo.pCode = _this.loginInfo.phone;
                    resolve(false);
                  } else {
                    await studentLoginByCode({
                      code: re.data.code,
                      pCode: _this.loginInfo.phone,
                      competitionId:this.id
                    })
                      .then((data) => {
                        if (data.data.isComplete) {
                          resolve(data);
                        } else {
                          this.studentInfo.code = data.data.tempRegCode;
                          this.studentInfo.pCode = _this.loginInfo.phone;
                          this.step = 2;
                          this.loginType = 2;
                          this.studentInfo.type = 2;
                          resolve(false);
                        }
                      })
                      .catch((err) => {
                        // this.$message.showMessage({ info: err.data.message });
                        this.errorMessage[this.step] = err && err.data && err.data.message;
                      });
                  }
                } else {
                  this.$message.showMessage({ info: re.errmsg });
                }
              },
              fail: (err) => {
                this.$message.showMessage({ info: err.errmsg });
                rej();
              },
            };
            window.TAL_UC.loginSms(param);
          });
        } else {
          res = await studentsRegComplete({competitionId:this.id,...this.studentInfo});
        }
        if (res) {
          // this.$store.commit('global/LOGIN', {
          //   userType: '1',
          //   result: res,
          // });
          // // window.location.reload();
          this.$emit('successLogin',res);
        }
      } catch (err) {
        // this.$message.showMessage({ info: err.data.message });
        this.errorMessage[this.step] = err && err.data && err.data.message;
      }
    },
    async handleTeacherLogin() {
      if (!await this.$refs.obs1.validate()) {
        return;
      }
      this.$store.dispatch('global/LOGIN', {
        userType: '0',
        params: this.teacherInfo,
      }).then((res) => {
        if (res.status === 200) {
          window.location.reload();
        }
      }).catch((err) => {
        // this.$message.showMessage({ info: err.data.message });
        this.errorMessage[this.step] = err.data.message;
      });
    },
    // C++ 诊断自动报名逻辑
    autoSignUpForDiagnose() {
      if(Number(this.compType) !== 3) return;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        autoSignupAfterLogin({competitionId:this.id})
          .then(res => {
            const { data: { data } } = res;
            this.$store.dispatch('setInsidSignUp', data);
          })
          .catch(err => {
            const { data: { status } } = err;
            if (status === 400) {
              this.$store.dispatch('setInsidSignUp', true);
            }
          });
      }, 100);
    },
    close() {
      this.$emit('closeLoginMessageBox');
    },
    showRegisterModal() {
      this.$emit('showRegisterModal');
    },
    showResetModal() {
      this.$emit('closeLoginMessageBox', true);
    },
    showDeleteModal() {
      this.$emit('showDeleteDialog');
      this.close();
    },
  },
  computed: {
    ...mapState({
        globalConfig: state => state.router.globalConfig,
        compType: state => state.router.compType,
        id: state => state.router.id,
    }),
    setColor(){
      return{
        'color':this.globalConfig.vice,
      }
    },
    setBgColor(){
      return{
        'backgroundColor':this.globalConfig.vice,
        'color':this.globalConfig.main,
      }
    },
    regDisabled() {
      return (
        Object.keys(this.studentInfo).some((key) => this.studentInfo[key] === '')
        || !this.isAgree
        || Object.keys(this.$refs.obs1.errors).some((key) => this.$refs.obs1.errors[key].length > 0)
      );
    },
  },
  watch: {
    step() {
      this.errorMessage = this.$options.data().errorMessage;
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/less/mixin.less";
@import "~@/assets/styles/captcha.less";

.login {
  text-align: center;
  &_title {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 33px;
  }
  &_role_change {
    .bg-img('~@/assets/images/switchRole') ;
    background-size: contain;
    height: 38px;
    width: 38px;
    margin-top: -19px;
    margin-right: -38px;
    top: 50%;
    right: 0;
    display: block;
    position: absolute;
    cursor: pointer;
    &:hover{
      .bg-img('~@/assets/images/switchRole-hover');
      background-size: contain;
    }
  }
  /deep/.el-input__suffix {
    right: 21px;
    width: 21.43px;
    margin: 0 -5px;
    .el-input__icon {
      width: 11.43px;
    }
    /deep/.el-icon-arrow-up:before{
      content: "";
      width: 12px;
      height: 8px;
      display:inline-block;
      .bg-img("~@/assets/images/suffix");
      background-size: contain;
      transform: scaleY(-1);
      margin-bottom: 2px;
    }
  }
  /deep/&.student.message-box {
    &__header {
      &.showicon {
         &::after {
          //  .bg-img('~@/assets/images/login-stu-icon')
         }
      }
    }
  }
  /deep/&.teacher.message-box {
    .message-box__header {
      &.showicon {
         &::after {
          //  .bg-img('~@/assets/images/login-teacher-icon')
         }
      }
    }
  }
}
.body__item {
  position: relative;
  text-align: center;
  z-index: 1;
  display:flex;
  justify-content:space-between;
  margin: 0 32px;
  &>span {
    width: 100%;
  }
  &+.body__item {
    margin-top: 16px;
  }
  .lab {
    display: inline-block;
    position:absolute;
    left: -40px;
    width:30px;
    height:40px;
    font-size:14px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:40px;
  }

  .body__item__input {
    width: 100%;
    height: 40px;
    background: rgba(255, 255, 255, 1);
    border-radius: 20px;
    border: 1px solid rgba(192, 192, 192, 1);
    outline: none;
    padding: 19px;
    box-sizing: border-box;
    line-height: 40px;
    font-size: 14px;
    /deep/.el-input__inner {
      height: 32px;
      border: 1px solid rgba(192, 192, 192, 1);
    }
  }
  /deep/input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 100px rgba(255, 253, 246, 0) inset;
    -webkit-text-fill-color: #7e7e7e;
  }
  input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 100px rgba(255, 253, 246, 1) inset;
    -webkit-text-fill-color: #7e7e7e;
  }
  /deep/input::-webkit-input-placeholder {
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:20px;
  }
  /deep/input::-webkit-input-placeholder {
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:20px;
    }
  /deep/input::-moz-input-placeholder {
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:20px;
    }
  /deep/input::-ms-input-placeholder {
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:20px;
    }
  /deep/input {
    color: #7e7e7e;
    padding: 0 20px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(190, 190, 190, 1);
    border-radius: 6px;
    outline: none;
    &:focus {
      background: rgba(255, 253, 246, 1);
    }
  }

  .body__item__input.code_input {
    width: 197px;
    margin-right:16px;
  }

  .sex_select{
    width: 100%;
    height: 40px;
    display: inline-flex;
    justify-content: space-between;
    .sex {
      cursor: pointer;
      width:140px;
      height:40px;
      background:rgba(255,255,255,1);
      border-radius:20px;
      text-align:center;
      line-height: 38px;
      display: flex;
      justify-content: center;
      align-items: center;
      border:1px solid rgba(192,192,192,1);

      &.male::before{
        content: "";
        display:inline-block;
        height: 32px;
        line-height: 38px;
        width: 32px;
        background: url("~@/assets/images/male.png");
        background-size: contain;
      }
      &.female::before{
        content: "";
        display:inline-block;
        height: 32px;
        width: 32px;
        line-height: 38px;
        background: url("~@/assets/images/female.png");
        background-size: contain;
      }
      &.male.active::before{
        background: url("~@/assets/images/male-active.png");
        background-size: contain;
      }
      &.female.active::before{
        background: url("~@/assets/images/female-active.png");
        background-size: contain;
      }
      &:hover,&.active {
        // background:rgba(104,149,60,1);
        // color: #fff;
        // border: none;
      }
    }
    /deep/.el-icon-arrow-up {
      line-height: 32px;
      &::before {
        content: "\e78f";
      }
    }
  }
  .body__item__select {
    width:100%;;
    height:40px;
    background:rgba(255,255,255,1);
    border-radius:20px;
    border:1px solid rgba(192,192,192,1);
    /deep/.el-input__inner {
      border: none;
      background: none;
    }
    &+.body__item__select {
      margin-left: 17px;
    }
  }

  &.info {
    margin-left: 72px;
  }
}
.body__sign {
  text-align: center;
  span {
    font-size:14px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(104,149,60,1);
    &:hover {
      cursor: pointer;
    }
  }
  span + span::before {
    content: "|";
    display: inline-block;
    padding: 0px 8px;
    color: #979797;
  }
}
.register .tip {
  margin-left: -20px;
}
.tip {
  // position: absolute;
  // bottom: 21px;
  width: 100%;
  text-align: center;
  margin: 4px 0px -12px;
  display: block;

  font-size:12px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(233,43,51,1);
  line-height:17px;
}
.code.tip {
  margin-left: 66px;
  margin-right: -66px;
}
.show-agreement {
  font-size: 14px;
  color: #507B36;
  &:hover {
    cursor: pointer;
  }
}
.body__agreement {
  margin-top: 16px;
  &__label {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 7px;
    background:rgba(255,255,255,1);
    border:1px solid rgba(186,186,186,1);
    position: relative;
  }
  &__checkbox:checked + &__label {
    background: url("~@/assets/images/checked.png");
    background-size: contain;
    border: none;
  }
}
.backToSignin {
  width:56px;
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(104,149,60,1);
  line-height:20px;
  cursor:pointer;
}
</style>
